import { Box, Image, Link, useMediaQuery } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import qs from "query-string";
import { breakpoints } from "@/theme/breakpoints";
import NoImage from "@/assets/no-image.png";
import { resizeServingUrl } from "@/utils/image";
import { IRSSItem } from "@/models/rss-item";
import "./rssCarousel.css"; // Assuming you have some styles in this file

type Props = {
  isApp: boolean;
  items: IRSSItem[];
};

const StyledSwiper = styled(Swiper)`
  width: 100%;
  padding: 16px;
`;

const StyledSwiperSlide = styled(SwiperSlide)`
  width: 100%;
  height: 100%;
`;

export const RSSCarousel = ({ isApp, items }: Props) => {
  const [isLargerThanMd] = useMediaQuery([`(min-width: ${breakpoints.md})`]);

  return (
    <Box w="100%">
      <StyledSwiper
        spaceBetween={12}
        slidesPerView={isLargerThanMd ? 2.5 : 1.5}
        navigation={isLargerThanMd}
        loop
        autoplay={{
          delay: 2000,
        }}
        modules={[Navigation, Autoplay]}
      >
        {items.map((item) => (
          <StyledSwiperSlide key={item.title}>
            <Link
              href={
                isApp
                  ? qs.stringifyUrl({
                      url: "teller-studio://in-app-webview",
                      query: {
                        url: item.link,
                      },
                    })
                  : item.link
              }
              target={isApp ? "_self" : "_blank"}
              w="full"
            >
              <Image
                w="100%"
                aspectRatio={62 / 35}
                alt={item.title}
                src={
                  item.thumbnailUrl
                    ? resizeServingUrl(item.thumbnailUrl, 400)
                    : NoImage
                }
                borderRadius={8}
                objectFit="cover"
              />
            </Link>
          </StyledSwiperSlide>
        ))}
      </StyledSwiper>
    </Box>
  );
};
